

import React, { useRef, useState } from "react";
import Layout from "../components/Layout";
import Drawer from "../components/Drawer";
import Footer from "../components/Footer";
import classes from "./ShortzPage.module.css";

import Feed from "../components/Feed";
import ScrollToTopButton from "../components/ScrollToTopButton";

const ShortzPage = () => {
  const containerRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);

  const handleScroll = () => {
    if (containerRef.current.scrollTop > 300) {
      setShowScrollButton(true);
    } else {
      setShowScrollButton(false);
    }
  };

  return (
    <Layout active={null}>
      <Drawer active={null} />
      <Feed
        containerRef={containerRef}
        onScroll={handleScroll}
        classes={classes}
      />
      <Footer />

      {/* ⬇️ Move ScrollToTopButton *after* footer so it floats freely */}
      <ScrollToTopButton
        containerRef={containerRef}
        isVisible={showScrollButton}
      />
    </Layout>
  );
};

export default ShortzPage;
